import React from 'react';
import styled from '@emotion/styled';

import { Flex } from 'common/components/Flex';
import type { CheckboxFieldProps } from 'common/components/Form/CheckboxField';
import CheckboxField from 'common/components/Form/CheckboxField';
import { linkStyles } from 'common/components/Link';
import { BodyRegularBR2 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { FieldName } from '../enums';

type CommonCheckboxProps = Pick<CheckboxFieldProps<FieldName>, 'name' | 'value' | 'onChange'>;

type NewsletterConsentCheckboxProps = CommonCheckboxProps;

const HelpText = styled(BodyRegularBR2)`
  a {
    ${props => linkStyles({ styled: true, textDecoration: 'underline', ...props })};
  }
`;

export const NewsletterConsentCheckbox = ({
  name,
  value,
  onChange,
}: NewsletterConsentCheckboxProps) => {
  const { r, t, prefix } = useLocalization();

  const checkboxLabel = (
    <BodyRegularBR2
      as="span"
      color="sys.neutral.text.strong"
      dangerouslySetInnerHTML={{ __html: t('h24_newsletter_disclaimer_label') }}
    />
  );

  return (
    <Flex
      p="sp_16"
      borderWidth="small"
      borderStyle="solid"
      borderRadius="medium"
      flexDirection="column"
      borderColor="sys.neutral.border.inactive"
    >
      <CheckboxField label={checkboxLabel} onChange={onChange} name={name} value={value} />
      <HelpText
        ml="sp_32"
        color="sys.neutral.text.strong"
        dangerouslySetInnerHTML={{
          __html: r.t('h24_newsletter_disclaimer_link', {
            href: prefix(t('h24_newsletter_disclaimer_link_url')),
          }),
        }}
      />
    </Flex>
  );
};
